import { group, route, meta } from '@/helpers/routes'

import Dashboard from './gadget/index'

const bashboardPatientRoutes = [
  route('index', '/index', Dashboard, meta('Dashboard Paciente', true, 'guest'))
]

export default [
  ...group('/app/patient/dashboard', bashboardPatientRoutes)
]



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/routes.js